import React from 'react'
import styles from './styles.css'
import SignIcon from 'react-icons/lib/md/assignment-turned-in'
import MdAssignmentLate from 'react-icons/lib/md/assignment-late'
import MyDocumentsIcon from 'react-icons/lib/md/work'
import TemplatesIcon from 'react-icons/lib/md/library-books'
import TiGroupOutline from 'react-icons/lib/ti/group-outline'
import SettingsIcon from 'react-icons/lib/md/settings'
import FileBinary from 'react-icons/lib/go/file-binary'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import InfoIcon from 'react-icons/lib/md/info'
import {Link, withRouter} from 'react-router'
import PropTypes from 'prop-types'
import FixedHeader from 'App/components/FixedHeader'
import {Desktop, Tablet, Mobile} from 'App/components/Devices'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import withOrganization from 'App/Decorators/withOrganization'
import Button from 'orionsoft-parts/lib/components/Button'
import get from 'lodash/get'


@withRouter
@withOrganization
@withGraphQL(
  gql`
    query myDocumentsToSign($organizationId: String) {
      myDocumentsToSign(organizationId: $organizationId) {
        totalCount
      }
    }
  `,
  {
    //  options: {pollInterval: 1000}
  }
)

@withGraphQL(
  gql`
    query myFeaDocumentsToSign($organizationId: String) {
      myFeaDocumentsToSign(organizationId: $organizationId) {
        totalCount
      }
    }
  `,
  {
    //  options: {pollInterval: 1000}
  }
)

@withGraphQL(gql`
  query me {
    me {
      _id
      emails {
        address
        verified
      }
      isActive
      roles
      isSimpleAccount
      hasPassword
      lastKnownLocation {
        date
      }
    }
  }
`)

@withGraphQL(
  gql`
    query planSignaturesCount {
      planSignaturesCount
    }
  `
)

@withGraphQL(
  gql`
    query packsSignaturesCount {
      packsSignaturesCount
    }
  `
)

@withMutation(gql`
  mutation invalidarFirmasMigradas {
    invalidarFirmasMigradas {
      success
    }
  }
`)

export default class Sidebar extends React.Component {

  state = {}

  static propTypes = {
    router: PropTypes.object,
    me: PropTypes.func,
    organization: PropTypes.object,
    myDocumentsToSign: PropTypes.func,
    myFeaDocumentsToSign: PropTypes.func,
    planSignaturesCount: PropTypes.object,
    packsSignaturesCount: PropTypes.object,
    invalidarFirmasMigradas: PropTypes.func
  }

  active(path) {
    return this.props.router.location.pathname.startsWith(path) ? 'active' : ''
  }

  renderSign(isSimpleAccount) {

    const documentsToSign = this.props.myDocumentsToSign
      ? this.props.myDocumentsToSign.totalCount
      : null
    const feaDocumentsToSign = this.props.myFeaDocumentsToSign
      ? this.props.myFeaDocumentsToSign.totalCount
      : null
    if (isSimpleAccount) {
      return (
        <div className={this.active('/sign')}>
          <Link to="/sign">
            <SignIcon size={22} />
            {documentsToSign ? <span className={styles.toSign}>{documentsToSign}</span> : null}
            {feaDocumentsToSign ? <span className={styles.feaToSign}>{feaDocumentsToSign}</span> : null}
            <span>Documentos por Firmar</span>
          </Link>
        </div>
      )
    } else {
      return (
        <div className={this.active('/sign')}>
          <Link to="/sign">
            <SignIcon size={22} />
            {documentsToSign ? <span className={styles.toSign}>{documentsToSign}</span> : null}
            {feaDocumentsToSign ? <span className={styles.feaToSign}>{feaDocumentsToSign}</span> : null}
            <span>Firmar / Crear Documento</span>
          </Link>
        </div>
      )
    }

  }

  renderSignaturesLeft(isSimpleAcocunt) {

    if (isSimpleAcocunt) {
      return
    }

    var dataPlan = this.props.planSignaturesCount
    var dataPacks = this.props.packsSignaturesCount

    if (dataPlan && dataPacks) {
      let simplesDisponibles = dataPlan.simplesTotales + dataPacks.simplesTotales - dataPlan.simplesUsadas - dataPacks.simplesUsadas
      let avanzadasDisponibles = dataPlan.avanzadasTotales + dataPacks.avanzadasTotales - dataPlan.avanzadasUsadas - dataPacks.avanzadasUsadas
      let facialesDisponibles = dataPlan.facialesTotales + dataPacks.facialesTotales - dataPlan.facialesUsadas - dataPacks.facialesUsadas
      if(!facialesDisponibles)
        facialesDisponibles=0;
      let warningStyle = ''
      if (simplesDisponibles < 4) {
        warningStyle = styles.signaturesLeftDetailWarning
      }

      return (
        <div className={this.active('/settings/firmasDigitales')}>
          <Link to="/settings/firmasDigitales">
            <span><FileBinary size={22} />Firmas Disponibles</span>
            <div className={styles.signaturesLeftDetail}>
              <p>
                <span className={warningStyle}><b>{simplesDisponibles}</b> Firmas Simples</span>
              </p>
              <p>
                <span className={warningStyle}><b>{avanzadasDisponibles}</b> Firmas Avanzadas</span>
              </p>
            </div>
          </Link>
          {this.renderComprarCTA(simplesDisponibles, avanzadasDisponibles)}
        </div>
      )
    }
  }

  // <p><span className={warningStyle}><b>{facialesDisponibles}</b> Firmas Faciales</span></p>

  renderComprarCTA(simplesDisponibles, avanzadasDisponibles) {
    if (simplesDisponibles < 4) {
      return (
        <div className={styles.buyButton}>
          <Button primary onClick={() => this.props.router.push(`/settings/firmasDigitales`) } >
              Comprar Firmas
          </Button>
        </div>
      )
    }
  }

  renderOrganization() {
    if (true || !this.props.organization || !this.props.organization._id) return
    return (
      <div className={styles.container}>
        <div className={styles.divider} />
        <div className={this.active('/organization')}>
          <Link to={`/organization/users`}>
            <TiGroupOutline size={22} />
            <span>Organización</span>
          </Link>
        </div>
      </div>
    )
  }

  renderTemplates(isSimpleAccount) {
    if (!isSimpleAccount) {
      return (
        <div className={this.active('/templates')}>
            <Link to="/templates?contextUrl={contextUrl}">
              <TemplatesIcon size={22} />
              <span>Plantillas</span>
            </Link>
          </div>  
      )
    }
  }

  async gotoNuevaPlataforma() {
    if (window.confirm('Para el proceso de migración deberás usar el mismo email de tu cuenta actual y realizar un cambio de contraseña. Tus firmas disponibles serán migradas a la nueva plataforma y quedarán inactivas en la actual. Recomendamos que antes de migrar, agendes tu capacitación para no interrumpir tus operaciones. +56 9 8287 8123')) {
      console.log("Migrando...");
      await this.props.invalidarFirmasMigradas()
      window.location.href = 'https://v2.tufirma.digital/auth/forgot-password'
    } 
  }

  renderSimpleAccountBtn(isSimpleAccount) {
    if (isSimpleAccount) {
      return (
        <div>
          <br/>
          <Button onClick={() => this.props.router.push(`/settings/state`) } >
              Crear documentos
          </Button>
        </div>
      )
    }
  }

  renderModules() {
    const me = get(this.props, 'me') || {}
    // console.log("esCuenta simple:", me.isSimpleAccount )
    return (
      <div className={styles.container}>
        {this.renderSignaturesLeft(me.isSimpleAccount)}
        {this.renderSign(me.isSimpleAccount)}
        {this.renderTemplates(me.isSimpleAccount)}

        <div className={this.active('/documents')}>
          <Link to="/documents">
            <MyDocumentsIcon size={22} />
            <span>Mis documentos</span>
          </Link>
        </div>
        <div className={this.active('/documentverify')}>
          <Link to="/documentverify">
            <MdAssignmentLate size={22} />
            <span>Verificar documento</span>
          </Link>
        </div>
        <div className={this.active('/settings')}>
          <Link to="/settings">
            <SettingsIcon size={22} />
            <span>Mi cuenta</span>
          </Link>
        </div>
        <div>
          <Link to="https://www.tufirma.digital/como-funciona" target="_blank">
            <InfoIcon size={22} />
            <span>Preguntas Frecuentes</span>
          </Link>
        </div>
        {this.renderSimpleAccountBtn(me.isSimpleAccount)}

        <div>
        <Button
            className={styles.sign}
            primary
            onClick={() => this.gotoNuevaPlataforma() } >
              Prueba la nueva plataforma
          </Button>
        </div>

      </div>
    )
  }

  render() {
    console.log('Route /Sidebar')

    return (
      <div className='sidebar'>
        <Desktop>
          <FixedHeader paddingTop={50}>
            {this.renderModules()}
            {this.renderOrganization()}
          </FixedHeader>
        </Desktop>
        <Tablet>
          {this.renderModules()}
          {this.renderOrganization()}
        </Tablet>
        <Mobile>
          {this.renderModules()}
          {this.renderOrganization()}
        </Mobile>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Layout/Sidebar/index.js